import { Switch } from '@headlessui/react';

const ToggleButton = ({
  enabled,
  setEnabled,
}: {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  className?: string;
}) => {
  return (
    <Switch
      checked={enabled}
      onChange={setEnabled}
      className={`${
        enabled ? 'bg-brand-tangerine' : 'bg-brand-granite'
      } relative inline-flex h-[20px] w-[36px] shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none`}
    >
      <span className="sr-only">Use setting</span>

      <span
        aria-hidden="true"
        className={`${
          enabled ? 'right-1' : 'left-1'
        } pointer-events-none inline-block h-[8px] w-[8px] rounded-full bg-brand-black duration-200 ease-in-out absolute top-1/2 -translate-y-1/2 transition-all`}
      />
    </Switch>
  );
};

export default ToggleButton;
